/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import { formatDistance } from 'date-fns';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { connect } from 'react-redux';
import {
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  editAssignedNumber,
  getPortCallHistory,
  onRemoveAtaNumber,
  onMonitorAtaNumber,
  getObiSystemStatus,
  portConfig,
  getPortValues,
  getAssignedNumbers,
  selectBoxDetailsPort,
  getEpikBoxData,
  trunkPortConfig,
  getPhysicalStatus,
  obiRebootRequired,
  boundForwardNumber,
  boundRemoveNumber,
} from '../../../actions/EpikBoxes';
import {
  cancelAddNumber,
  editNumberCancel,
  updateNumber,
  forceFixNumber,
} from '../../../actions/Numbers';
import { assignRouteInfo, getGateways } from '../../../actions/Provisioning';
import DeleteModal from '../../DeleteModal';
import AddBoxNumberModal from './AddBoxNumberModal';
import EditBoxNumberModal from './EditBoxNumberModal';
import PortProperty from './PortProperty';
import './selectedPortPanel.css';
import PortConfigModal from './PortConfigModal';
import getObiData from '../../../containers/epikBoxes/helpers';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import Spinner from '../../Spinner/Spinner';
import DropdownSelect, { findSelectedOption } from '../../ProposalGenerator/DropdownSelect';
import { evenValues, oddValues, trunkOptions } from '../constants';
import {
  assignAction,
  sendBulkActionsToApi,
  unassignAction,
  enableAction,
  disableAction,
} from '../../../actions/BoxSessionLogging';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import CustomModal from '../../CustomModal';
import ForwardNumber from '../../form/ForwardNumber';
import utils, { isAdminRole } from '../../../lib/utils';
import Toggle from '../../Toggle';
import PortAtaProperty from './PortAtaProperty';
import AddAtaBoxNumberModal from './AddAtaBoxNumberModal';
import EditAtaNumberModal from './EditAtaNumberModal';
import InfoPopup from '../../InfoPopup';
import { TOOLTIPS_TEXT } from '../../../lib/constants';
class SelectedAtaPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingProperty: null,
      showModal: false,
      showError: false,
      isLoading: false,
      portModal: props.showPortDetail,
      showEditModal: false,
      selectedNumber: '',
      modalStatus: false,
      showHistoryModal: false,
      historyPortCall: [],
      portObiSystemList: [],
      loadingConfig: false,
      settings: [],
      settingsValidationRules: [],
      securityCheck: false,
      selectedValue: '',
      wrongSecurityCode: '',
      trunkOptions:
        props.port?.assignedNumberRef?.trunkSelection &&
          props.port?.assignedNumberRef?.trunkSelection !== '1'
          ? trunkOptions.filter(item => item.value !== '1')
          : trunkOptions,
      selectedTrunkOption: findSelectedOption(
        {
          value: props.port?.assignedNumberRef?.trunkSelection,
        },
        trunkOptions,
      ),
      fwdModalState: false,
      fwdNumber: props.port?.assignedNumberRef?.isForwarded
        ? props.port?.assignedNumberRef?.forwardNumbers[0]
        : '+1',
      fwdCheck: !props.port?.assignedNumberRef?.isForwarded,
      portBtnLoading: false,
      portPhysicalData: {},
      monitor: props.port?.monitored || false,
      outbound: props.port?.forceForward || false,
      outboundNumber: props.port?.forceForwardNumber || '',
      outboundNumberBtnLoading: false,
      historyStatus: true,
      forceFix: false,
    };

    const lastUpdatedDistanceValue = lastUpdated => {
      return lastUpdated
        ? formatDistance(new Date(), new Date(lastUpdated), { addSuffix: true })
        : '-';
    };

    const e911NumberValue = e911Number => !!e911Number;

    this.portDetailsProps = [
      {
        key: 'boxPortNumber',
        prop: 'boxPortNumber',
        label: 'Port Number',
        icon: 'hashtag',
        editable: false,
        hidden: false,
      },
      {
        key: 'portLabel',
        prop: 'portLabel',
        label: 'Port Label',
        icon: 'hashtag',
        value: () => props.port?.assignedNumberRef?.portLabel || 'No Port Label',
        editable: false,
        hidden: false,
      },
      {
        key: 'lastUpdated',
        prop: 'lastUpdated',
        label: 'Last Updated',
        icon: 'clock',
        editable: false,
        value: lastUpdatedDistanceValue,
        hidden: false,
      },
      {
        key: 'assignedNumber',
        prop: 'assignedNumber',
        label: 'Assigned Number',
        icon: 'hashtag',
        editable: true,
        hidden: false,
      },
      {
        key: 'e911Number',
        prop: 'e911Number',
        label: 'E911 Number',
        editable: true,
        value: e911NumberValue,
        hidden: !props?.boxDetails?.myEpik || false,
      },
    ];
    this.boxRef = React.createRef();
    this.updatedPort = '';
    this.editRouteReq = {
      token: null,
    };
    this.token = localStorage.getItem('jwtToken') || null;
  }

  async componentDidMount() {
    const { getGateways, user } = this.props;
    // this.onPortStatus();
    this.onAssignedNumber();
    this.onObiSystemStatus();
    if (
      user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager' ||
      user.role === 'supportEngineer'
    ) {
      await getGateways(this.token);
    }
    this.checkHistoryStatus();
  }

  // eslint-disable-next-line react/sort-comp
  checkHistoryStatus = () => {
    const { port } = this.props;
    const { assignedNumberRef } = port;
    if (assignedNumberRef) {
      if (!!port.assignedNumber?.number || port.assignedNumber?.number !== 'N/A') {
        this.setState({
          historyStatus: false,
        });
      } else {
        this.setState({
          historyStatus: true,
        });
      }
    } else {
      this.setState({
        historyStatus: true,
      });
    }
  };

  onPortStatus = async () => {
    this.setState({ portBtnLoading: true });
    const { getPhysicalStatus, port, boxDetails } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId =
      boxDetails.Obis.length === 1 ? boxDetails.Obis[0]._id : boxDetails.Obis[checkObi]._id;
    const portPhysical = await getPhysicalStatus(this.token, obiId, portNumber);
    this.setState({ portBtnLoading: false, portPhysicalData: portPhysical });
  };

  componentWillReceiveProps(props) {
    const { onConfigResp } = props;
    if (onConfigResp !== null) {
      this.setState({ showError: true });
      this.setState({ isLoading: false });
    } else {
      this.setState({ showError: false });
    }
  }

  onAssignedNumber = async () => {
    const { boxDetails, getAssignedNumbers } = this.props;
    await getAssignedNumbers(
      this.token,
      boxDetails.assignedTo._id,
      boxDetails.epikBoxUser._id,
      false,
    );
  };

  confirmCheck = async () => {
    const {
      port,
      boxDetails,
      updateNumber,
      getEpikBoxData,
      trunkPortConfig,
      onOutsideClick,
    } = this.props;
    const { selectedTrunkOption } = this.state;

    this.setState({ securityCheck: false });
    await updateNumber(this.token, {
      ...port?.assignedNumberRef,
      trunkSelection: selectedTrunkOption,
    });
    await trunkPortConfig(this.token, {
      vpnAddress: boxDetails?.vpnAddress,
      selectedPort: port?.boxPortNumber
        .split(' ')
        .join('')
        .toLowerCase(),
      number: { ...port?.assignedNumberRef, trunkSelection: selectedTrunkOption },
    });
    getEpikBoxData(this.token, boxDetails._id);
    onOutsideClick();
  };

  onForceFixBtn = async () => {
    const { forceFixNumber, boxDetails, port } = this.props;
    await forceFixNumber(this.token, port?.assignedNumberRef._id, boxDetails._id);
  };

  onObiSystemStatus = async () => {
    this.setState({ isLoading: true });
    const { getObiSystemStatus, port, boxDetails } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const obiStatus = await getObiSystemStatus(this.token, boxDetails._id, portNumber);
    const obiStatusArray =
      typeof obiStatus?.portObiSystemStatus === 'object'
        ? Object.keys(obiStatus?.portObiSystemStatus)
        : [];
    const newPortObiArray = [];
    obiStatusArray?.length > 0 &&
      obiStatusArray.map(item => {
        if (portNumber % 2 === 0) {
          if (item !== 'sp1ServiceStatus') {
            newPortObiArray.push(obiStatus?.portObiSystemStatus[item]);
          }
        } else if (item !== 'sp2ServiceStatus') {
          newPortObiArray.push(obiStatus?.portObiSystemStatus[item]);
        }
      });
    this.setState({
      portObiSystemList: newPortObiArray,
      isLoading: false,
    });
  };

  handleClick = e => {
    if (this.boxRef.current.contains(e.target) || e.target.closest('.boxAtaPortContainer')) {
      return;
    }
    this.props.onOutsideClick();
  };

  configObi = async reset => {
    const { boxDetails, port, portConfig, updatePortConfig } = this.props;
    const updatedPort = { ...port, e911Number: reset ? '' : boxDetails.e911Number };
    const { portKey } = updatedPort;
    boxDetails.Obis[updatedPort.obiIndex][portKey] = updatedPort;
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: boxDetails.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: boxDetails.Obis[updatedPort.obiIndex],
    };
    const res = await portConfig(this.token, body);
    if (res) {
      this.setState({ portModal: false });
      updatePortConfig();
    }
  };

  onEditPropertyKeyPress = ev => {
    const keyCode = typeof ev.which === 'number' ? ev.which : ev.keyCode;
    const { name } = ev.target;
    const { value, checked } = ev.target;

    // Enter key

    if (name === 'e911Number') {
      this.configObi(!checked);
    } else {
      if (keyCode === 13 || name) {
        if (value === 'Custom') {
          setTimeout(() => {
            this.setState({ showError: false });
          }, 100);
          this.setState({ showModal: true });
        } else {
          this.updatedPort = {
            ...this.updatedPort,
            [name]: value,
          };
          for (const propName in this.updatedPort) {
            if (
              this.updatedPort[propName] === null ||
              this.updatedPort[propName] === undefined ||
              this.updatedPort[propName] === ''
            ) {
              delete this.updatedPort[propName];
            }
          }
          this.setState({
            editingProperty: null,
          });
          return;
        }
      }
      // Escape key
      if (keyCode === 27) {
        this.setState({
          editingProperty: null,
        });
      }
    }
  };

  onEditProperty = editingProperty => {
    this.setState({ editingProperty });
  };
  onForceFix = value => {
    this.setState({
      forceFix: value,
    });
  };

  onSelectNumber = ({ suggestion }, vmail) => {
    if (suggestion !== null) {
      this.props.editAssignedNumber(suggestion);
      this.props.assignRouteInfo(this.token, suggestion._id);
      this.setState({
        selectedNumber: suggestion,
        showEditModal: true,
        vmail: !!vmail,
      });
    }
  };

  onRemoveNumber = async () => {
    const { boxDetails, onRemoveAtaNumber, removeAssignedAta } = this.props;
    const updatedPortData = {
      ...this.props.port,
      ...this.updatedPort,
    };
    // console.log('checking onRemoveNumber ::::', updatedPortData);

    // for (const propName in updatedPortData) {
    //   if (
    //     updatedPortData[propName] === null ||
    //     updatedPortData[propName] === undefined ||
    //     updatedPortData[propName] === ''
    //   ) {
    //     delete updatedPortData[propName];
    //   }
    // }
    // this.updatedPort = '';
    // const unassignedNumId = updatedPortData.assignedNumberRef._id
    //   ? updatedPortData.assignedNumberRef._id
    //   : updatedPortData.assignedNumberRef;
    const body = {
      number: updatedPortData.assignedNumber,
    };
    const ataNumber = boxDetails.externalAta[0]._id;
    const removeAta = await onRemoveAtaNumber(this.token, ataNumber, body);
    await getEpikBoxData(this.token, boxDetails._id);
    this.setState({ modalStatus: false });
    this.props.onOutsideClick();
    this.updatedPort = '';
    removeAssignedAta(true);
    // console.log('checking removeAta :::', removeAta);

    // this.props.onPortUpdate(updatedPortData, unassignedNumId);
  };

  onAddNewNumber = (e, vmail) => {
    this.props.cancelAddNumber();
    this.props.editNumberCancel();
    this.setState({ showAddNumber: e, vmail: !!vmail });
  };

  renderPortDetailsProperties = () => {
    return this.portDetailsProps.map(({ key, label, icon, editable, value, hidden }) => {
      return this.props.user.role === 'superAdmin' ||
        this.props.user.role === 'companyGroupAdmin' ||
        this.props.user.role === 'supportEngineer' ? (
        <PortAtaProperty
          handleFwdToggle={() => {
            this.setState({ fwdModalState: true });
          }}
          onOutsideClick={() => this.props.onOutsideClick()}
          boxDetails={this.props.boxDetails}
          onAddNewNumber={this.onAddNewNumber}
          // assignedNumbers={this.props.assignedNumbers}
          onSelectNumber={this.onSelectNumber}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
          deleteMode={this.props.deleteMode}
          user={this.props.user}
          key={key}
          prop={key}
          label={label}
          icon={icon}
          editable={editable}
          hidden={hidden}
          value={value}
          port={this.props.port}
          onEditProperty={this.onEditProperty}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          editing={this.state.editingProperty === key}
          forceFix={this.onForceFix}
        />
      ) : key !== 'remoteHost' && key !== 'remotePort' ? (
        <PortAtaProperty
          onOutsideClick={() => this.props.onOutsideClick()}
          boxDetails={this.props.boxDetails}
          onAddNewNumber={this.onAddNewNumber}
          // assignedNumbers={this.props.assignedNumbers}
          onSelectNumber={this.onSelectNumber}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
          deleteMode={this.props.deleteMode}
          user={this.props.user}
          key={key}
          prop={key}
          label={label}
          icon={icon}
          editable={editable}
          hidden={hidden}
          value={value}
          port={this.props.port}
          onEditProperty={this.onEditProperty}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          editing={this.state.editingProperty === key}
          forceFix={this.onForceFix}
        />
      ) : null;
    });
  };

  onCancel = () => {
    this.setState({ showModal: false });
  };

  onConfirm = () => {
    this.setState({ isLoading: true });
    const updatedPort = {
      ...this.props.port,
      serviceName: 'Custom',
    };
    for (const propName in updatedPort) {
      if (
        updatedPort[propName] === null ||
        updatedPort[propName] === undefined ||
        updatedPort[propName] === ''
      ) {
        delete updatedPort[propName];
      }
    }
    this.setState({
      editingProperty: null,
    });

    this.props.onUploadPortConfig(this.state.uplaodedFile, updatedPort);
  };

  saveUpdatedPort = () => {
    const updatedPortData = {
      ...this.props.port,
      ...this.updatedPort,
    };
    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }

    this.updatedPort = '';
    this.props.onPortUpdate(updatedPortData);
    setTimeout(() => {
      this.props.onOutsideClick();
    }, 500);
  };

  handleChangeUpload = e => {
    this.setState({ uplaodedFile: e.target.files[0] });
  };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  selectRoute = async (id, body, update = true) => {
    this.props.updateNumberRoute(id, body, true);
  };

  onHistoryCall = async () => {
    const { port, boxDetails } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const historyCalls = await this.props.getPortCallHistory(
      this.token,
      boxDetails._id,
      portNumber,
    );
    if (historyCalls.portCallHistory === undefined) {
      toast.error('CALL HISTORY COULD NOT BE FETCHED');
    } else if (historyCalls.portCallHistory === 'CALL HISTORY COULD NOT BE FETCHED') {
      toast.error('CALL HISTORY COULD NOT BE FETCHED');
    } else if (historyCalls.portCallHistory === '' || historyCalls.portCallHistory === null) {
      toast.error('No call history found.');
    } else {
      const portNumber = port.boxPortNumber.split(' ');
      const newArray = [];
      if (
        historyCalls.portCallHistory.CallHistoryFile === '' ||
        historyCalls.portCallHistory === ''
      ) {
        toast.error('No call history found.');
      } else {
        historyCalls.portCallHistory.CallHistoryFile.CallHistory.map(item => {
          item.Event.map(itemInner => {
            if (portNumber[1] % 2 === 1) {
              if (itemInner.e0 === 'From PH1' || itemInner.e1 === 'To PH1') {
                newArray.push(item);
              }
            } else if (itemInner.e0 === 'From PH2' || itemInner.e1 === 'To PH2') {
              newArray.push(item);
            }
          });
        });
        this.setState({
          historyPortCall: newArray,
          showHistoryModal: true,
        });
      }
    }
  };

  onPortConfigure = async () => {
    const { getPortValues, port, boxDetails } = this.props;
    const portIdx = port.boxPortNumber.split(' ')[1];
    const obiId = getObiData(port.boxPortNumber, boxDetails, '_id');
    const values = portIdx % 2 === 0 ? evenValues : oddValues;
    this.setState({ loadingConfig: true });
    const res = await getPortValues(this.token, obiId, values);
    if (res) {
      this.setState({
        settings: res?.data?.settings,
        settingsValidationRules: res?.validationRules,
        showPortConfigModal: !!res?.data?.settings,
      });
    }
    this.setState({ loadingConfig: false });
  };

  validateNumber = async () => {
    const { port, enableAction } = this.props;
    const formattedNumber = parsePhoneNumberFromString(this.state.fwdNumber, 'US');

    if (formattedNumber && formattedNumber.country === 'US') {
      const body = {
        ...port?.assignedNumberRef,
        isForwarded: true,
        forwardNumbers: [formattedNumber?.number],
      };
      const response = await this.updateFwdNumber(body);
      if (response) {
        // [Action] - Add
        enableAction(`Add fwd number ${this.state.fwdNumber} from port`);
      }
    } else {
      toast.error('Invalid Number');
    }
  };

  removeFwdNumber = async () => {
    const { port, disableAction } = this.props;
    const body = {
      ...port?.assignedNumberRef,
      isForwarded: false,
      forwardNumbers: [],
    };
    const response = this.updateFwdNumber(body);
    if (response) {
      // [Action] - Delete
      disableAction(`remove fwd number ${this.state.fwdNumber} from port`);
    }
  };

  updateFwdNumber = async body => {
    const { boxDetails, updateNumber, onOutsideClick, getEpikBoxData } = this.props;

    const response = await updateNumber(this.token, body);
    await getEpikBoxData(this.token, boxDetails._id);

    this.setState({ fwdModalState: false });
    this.props.onOutsideClick();
    return response;
  };

  monitorToggle = async () => {
    this.setState({ isContainerLoading: true });
    const { port, onMonitorAtaNumber, boxDetails } = this.props;
    const { monitor } = this.state;
    const portNumber = port.boxPortNumber;
    const ataId = boxDetails.externalAta[0]._id;
    const body = {
      portID: port?._id,
      monitored: !monitor,
    };
    const response = await onMonitorAtaNumber(this.token, ataId, body);
    if (response) {
      this.onClose();
      this.setState({ monitor: !monitor });
      this.props.updatePortConfig();
    }
    this.setState({ isContainerLoading: false });
  };

  onClose = () => {
    this.updatedPort = '';
    this.props.onOutsideClick();
  };

  outboundToggle = async () => {
    const { outbound } = this.state;
    this.setState({ securityCheck: false, isOutboundSecuriety: false });
    const { port, boxDetails, boundRemoveNumber, getEpikBoxData } = this.props;
    const portNumber = port?.boxPortNumber.replace(/[^0-9]/g, '');
    const ataId = boxDetails.externalAta[0]._id;
    if (outbound) {
      const body = {
        port: `port${portNumber}`,
        externalATAID: ataId,
        portID: port?._id,
      };
      const res = await boundRemoveNumber(this.token, boxDetails._id, body);
      if (res) this.setState({ outbound: false });
      await getEpikBoxData(this.token, boxDetails._id);
    } else {
      this.setState({ outbound: true });
    }
  };

  onOutboundChange = e => {
    const { target } = e;
    if (!isNaN(target.value)) {
      this.setState({ outboundNumber: target.value });
    }
  };
  onOutboundNumber = async () => {
    const { port, boxDetails, boundForwardNumber, getEpikBoxData } = this.props;
    const { outboundNumber } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.externalAta[0]._id;
    const externalATAID = boxDetails.externalAta[0]._id;
    if (outboundNumber) {
      const body = {
        port: `port${portNumber}`,
        number: outboundNumber,
        // obiId,
        portID: port._id,
        externalATAID,
      };
      this.setState({ outboundNumberBtnLoading: true });
      await boundForwardNumber(this.token, boxDetails._id, body);
      await getEpikBoxData(this.token, boxDetails._id);
      this.setState({ outboundNumberBtnLoading: false });
    } else {
      toast.error('Invalid Number');
    }
  };
  render() {
    const {
      port,
      onConfigResp,
      boxDetails,
      gateways,
      user,
      box,
      updatePortConfig,
      selectedNumberType,
      assignAction,
      sendBulkActionsToApi,
    } = this.props;

    const {
      historyPortCall,
      portObiSystemList,
      isLoading,
      showPortConfigModal,
      loadingConfig,
      settings,
      settingsValidationRules,
      vmail,
      trunkOptions,
      selectedTrunkOption,
      portPhysicalData,
      portBtnLoading,
      outbound,
      outboundNumber,
      monitor,
      outboundNumberBtnLoading,
      historyStatus,
      isContainerLoading,
    } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const portCheck = portNumber % 2 === 0 ? 'Port 2' : 'Port 1';
    const historyButton = (
      <div>
        {!box?.myEpik ? !['admin', 'enterpriseAdmin'].includes(user.role)(
          <Button
            disabled={true}
            color="primary"
            style={{ marginRight: '10px' }}
            onClick={this.onPortConfigure}
          >
            {loadingConfig ? <SpinnerCircles /> : 'Port Configuration'}
          </Button>
        ) : null}
        <Button color="primary" onClick={this.onHistoryCall} disabled={true}>
          Port Call History
        </Button>
      </div>
    );
    return (
      <div id="selected-port-details" ref={this.boxRef}>
        <PortConfigModal
          port={port}
          updatePortConfig={updatePortConfig}
          boxDetails={boxDetails}
          settings={settings}
          settingsValidationRules={settingsValidationRules}
          isOpen={showPortConfigModal}
          refresh={this.onPortConfigure}
          isClose={() => this.setState({ showPortConfigModal: false })}
        />
        <Modal isOpen={this.state.showModal}>
          <ModalHeader>Service Name</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Configuration File:</Label>
              <Input
                type="file"
                accept=".config"
                onChange={this.handleChangeUpload}
                name="imagePage"
              />
            </FormGroup>
            {this.state.showError ? (
              onConfigResp.omitted && Object.keys(onConfigResp.omitted).length ? (
                <div>
                  <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                    <DropdownToggle caret>Click To see Omitted Values</DropdownToggle>
                  </Dropdown>

                  <div style={{ padding: '20px' }} hidden={!this.state.dropdownOpen}>
                    {Object.keys(onConfigResp.omitted).join(', ')}
                  </div>
                </div>
              ) : null
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button outline color="secondary" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button color="primary" disabled={this.state.isLoading} onClick={this.onConfirm}>
              {!this.state.isLoading ? 'Submit' : 'Loading'}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.portModal}>
          <ModalHeader close={historyButton}>
            {port?.assignedNumberRef?.type || 'Unassigned'}
          </ModalHeader>
          <ModalBody>
            {isContainerLoading && <Spinner />}
            <Row>
              <Col md={6}>{this.renderPortDetailsProperties()}</Col>
              <Col md={6}>
                <div>
                  <FormGroup row>
                    <Label for="showCallRecording" sm={8}>
                      Provisioned on:
                    </Label>
                    <Col md={12}>
                      {utils.getDateTimeFormat(this.props.port.provisionDate, 'both')}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    {/* <Col md={12}>
                      <div style={{ backgroundColor: '#888888' }}>
                        <p
                          style={{
                            margin: '2px 0px 2px 0px',
                            color: '#ffffff',
                            fontWeight: 'bold',
                          }}
                        >
                          Port Status:
                        </p>
                      </div>
                      {!!Object.keys(portPhysicalData).length &&
                        Object.entries(portPhysicalData)?.map(([key, value]) => {
                          return (
                            <div className="port-row">
                              <p style={{ margin: '0px' }}>{utils.toTitleCase(key)}: </p>
                              <p style={{ margin: '0px' }}>{value}</p>
                            </div>
                          );
                        })}
                    </Col>
                    <Col md={12} className="refresh-port">
                      <Button color="primary" onClick={this.onPortStatus} disabled={portBtnLoading}>
                        {!portBtnLoading ? 'Refresh' : <div className="loading-btn-spinner" />}
                      </Button>
                    </Col> */}
                    <Col className="d-flex align-items-center justify-content-center">
                      <p className="font-weight-bold">Data is not available</p>
                    </Col>
                  </FormGroup>

                  {/* {portObiSystemList.length > 0 &&
                    portObiSystemList.map(item => {
                      const itemObi = Object.values(item);
                      return (
                        <FormGroup row>
                          <Col md={12}>
                            <div>
                              <div style={{ backgroundColor: '#888888' }}>
                                <p
                                  style={{
                                    margin: '2px 0px 2px 0px',
                                    color: '#ffffff',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {item.placeHolder}:
                                </p>
                              </div>
                              {itemObi.map(innerItem => {
                                return (
                                  innerItem !== item.placeHolder && (
                                    <p style={{ margin: '0px' }}>{innerItem}</p>
                                  )
                                );
                              })}
                            </div>
                          </Col>
                        </FormGroup>
                      );
                    })} */}

                  {/* <Button
                    color="primary"
                    onClick={this.onObiSystemStatus}
                    disabled={!(portObiSystemList.length > 0 && !isLoading)}
                  >
                    {!isLoading ? 'Refresh OBI' : 'Loading...'}
                  </Button> */}
                </div>
                <FormGroup row>
                  <Label className="d-flex" for="name" sm={8}>
                    Monitor:
                    <sup>
                      <InfoPopup id="port-monitor" text={TOOLTIPS_TEXT.MONITOR} />
                    </sup>
                  </Label>
                  <Col md={12} className="d-flex">
                    <Toggle value={monitor} onToggle={this.monitorToggle} />
                    <span className="ml-2">{port?.boxPortNumber}</span>
                  </Col>
                </FormGroup>
                {!boxDetails.myEpik && (
                  <FormGroup row>
                    <Label for="name" sm={8} className="d-flex">
                      Outbound Number Override:
                      <sup>
                        <InfoPopup id="outbound-number" text={TOOLTIPS_TEXT.OUTBOUND_OVERRIDE} />
                      </sup>
                    </Label>
                    <Col md={12} className="d-flex">
                      <Toggle
                        value={outbound}
                        onToggle={() =>
                          this.setState({ securityCheck: true, isOutboundSecuriety: true })
                        }
                      // onToggle={this.outboundToggle}
                      />
                    </Col>
                    {outbound && (
                      <Col md={12} className="d-flex flex-row p-3">
                        <Input
                          placeholder="Please specify"
                          required
                          type="text"
                          name="outboundNumber"
                          value={outboundNumber}
                          maxLength={10}
                          onChange={this.onOutboundChange}
                        />
                        <Button
                          color="primary"
                          disabled={outboundNumberBtnLoading}
                          onClick={this.onOutboundNumber}
                        >
                          {!outboundNumberBtnLoading ? (
                            'Submit'
                          ) : (
                            <div className="loading-btn-spinner" />
                          )}
                        </Button>
                      </Col>
                    )}
                  </FormGroup>
                )}
              </Col>
            </Row>
            {!isAdminRole(this.props.user.role) && !box.myEpik && (
              <Row
                style={{ marginLeft: '0px', marginRight: '30px' }}
                hidden={
                  port?.assignedNumberRef?.type !== 'modem' &&
                  port?.assignedNumberRef?.type !== 'faxStandard' &&
                  port?.assignedNumberRef?.type !== 'fireAlarm' &&
                  port?.assignedNumberRef?.type !== 'alarm'
                }
              >
                <Col md={{ size: '6' }}>
                  <InputGroup style={{ flexWrap: 'nowrap' }}>
                    <InputGroupAddon
                      addonType="prepend"
                      style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                    >
                      <InputGroupText>
                        <i class="fas fa-cog"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <DropdownSelect
                      selectedOption={selectedTrunkOption}
                      options={trunkOptions}
                      onSelect={({ value }) => {
                        this.setState({ securityCheck: true });
                        this.setState({
                          selectedTrunkOption: value,
                          trunkOptions: trunkOptions.filter(item => item.value !== '1'),
                        });
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            )}
            {/* </div> */}
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.onClose} color="primary">
              Close
            </Button>
            {this.state.forceFix && (
              <Button color="danger" onClick={this.onForceFixBtn}>
                Force Fix
              </Button>
            )}
          </ModalFooter>
        </Modal>
        <AddSecurityCodeModal
          isOpen={this.state.securityCheck}
          onCancel={() => {
            this.setState({
              securityCheck: !this.state.securityCheck,
              wrongSecurity: !this.state.wrongSecurityCode,
              isOutboundSecuriety: false,
            });
          }}
          onConfirm={() =>
            this.state.isOutboundSecuriety ? this.outboundToggle() : this.confirmCheck()
          }
          trunkCode={!this.state.isOutboundSecuriety}
          multiCode={this.state.isOutboundSecuriety}
          featureName={this.state.isOutboundSecuriety ? 'outboundSecuriety' : 'trunkCode'}
        />

        {/* <--- History Call Modal ---> */}

        <Modal isOpen={this.state.showHistoryModal}>
          <ModalHeader>Port Call History</ModalHeader>
          <ModalBody style={{ height: '400px', overflow: 'auto' }}>
            {historyPortCall.length > 0 &&
              historyPortCall.map(item => {
                return (
                  <div>
                    <div style={{ backgroundColor: '#888888' }}>
                      <p
                        style={{ margin: '2px 0px 2px 0px', color: '#ffffff', fontWeight: 'bold' }}
                      >
                        {item['-time']} date:
                        {item['-date']}
                      </p>
                    </div>
                    {item.Event.map(item => {
                      return (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex' }}>
                            <p style={{ margin: '0px 5px 0px 0px', color: 'blue' }}>
                              {item['-time']}
                            </p>
                            <p style={{ margin: '0px' }}>{item.e0}</p>
                          </div>
                          <p style={{ margin: '0px' }}>{item.e1}</p>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </ModalBody>
          <ModalFooter>
            <Button
              outline
              color="secondary"
              onClick={() => {
                this.setState({ showHistoryModal: false });
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>

        {/* <--- End History Call Modal ---> */}

        <EditAtaNumberModal
          selectRoute={(id, body, update = false) => {
            this.selectRoute(id, body, update);
          }}
          vmail={vmail}
          gateways={gateways}
          boxDetails={boxDetails}
          selectedNumber={this.state.selectedNumber}
          isOpen={this.state.showEditModal}
          onCancel={() => {
            this.setState({ showEditModal: false });
          }}
          onConfirm={async () => {
            // [Action]- All Bulk Actions
            if (selectedNumberType === 'unassigned') {
              toast.error('Line type is required');
            } else {
              this.setState({ showEditModal: false });
              // [Action] - unassign
              await this.props.saveNumber('vmailType');
              // if (user.role !== 'admin' && !vmail) {
              //   this.saveUpdatedPort();
              // } else {
              this.props.onOutsideClick();
              // }
            }
          }}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
        />
        <AddAtaBoxNumberModal
          selectRoute={(id, body, update = false) => {
            this.selectRoute(id, body, update);
          }}
          gateways={gateways}
          vmail={vmail}
          boxDetails={boxDetails}
          isOpen={this.state.showAddNumber}
          onCancel={() => this.onAddNewNumber(false)}
          onConfirm={async editMode => {
            // [Action]- All Bulk Actions
            if (selectedNumberType === 'unassigned') {
              toast.error('Line type is required');
            } else {
              if (editMode) {
                await this.props.saveNumber(vmail);
                // if (!vmail) {
                //   this.saveUpdatedPort();
                // } else {
                this.props.onOutsideClick();
                // }
              } else {
                this.props.onAddNumber();
                this.onAddNewNumber(false);
              }
            }
          }}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
        />

        <DeleteModal
          data="remove"
          isOpen={this.state.modalStatus}
          onCancel={() => this.setState({ modalStatus: false })}
          onConfirm={this.onRemoveNumber}
        />

        <CustomModal
          header="Forward Number"
          onConfirm={this.state.fwdCheck ? this.validateNumber : false}
          isOpen={this.state.fwdModalState}
          onCancel={() => this.setState({ fwdModalState: false })}
        >
          <ForwardNumber
            fwdCheck={this.state.fwdCheck}
            fwdNumber={this.state.fwdNumber}
            onDeleteFwdNumber={this.removeFwdNumber}
            handleChange={e => {
              this.setState({ fwdNumber: e });
            }}
          />
        </CustomModal>
      </div>
    );
  }
}

SelectedAtaPanel.propTypes = {
  port: PropTypes.object,
  onPortUpdate: PropTypes.func,
};

const mapStateToProps = state => ({
  onConfigResp: state.AppState.obis.unassignedObis.obiResp || null,
  assignedNumbers: state.AppState.obis.assignedNumbers || [],
  user: state.AppState.user,
  deleteMode: state.AppState.deleteMode,
  gateways: state.AppState.provisioning.gateways,
  obiSystemStatus: state.AppState.boxDetails.obiSystemStatus,
  box: state.AppState.boxDetails.box,
  selectedNumberType: state.UIState.numbers.editNumber.type,
});

const mapDispatchToProps = dispatch => ({
  editAssignedNumber: id => dispatch(editAssignedNumber(id)),
  obiRebootRequired: (token, id, payload) => dispatch(obiRebootRequired(token, id, payload)),
  getPortCallHistory: (token, bid, portNumber) =>
    dispatch(getPortCallHistory(token, bid, portNumber)),
  onRemoveAtaNumber: (token, ataNumber, body) =>
    dispatch(onRemoveAtaNumber(token, ataNumber, body)),
  onMonitorAtaNumber: (token, ataNumber, body) =>
    dispatch(onMonitorAtaNumber(token, ataNumber, body)),
  getObiSystemStatus: (token, bid, portNumber) =>
    dispatch(getObiSystemStatus(token, bid, portNumber)),
  getPhysicalStatus: (token, bid, portNumber) =>
    dispatch(getPhysicalStatus(token, bid, portNumber)),
  getGateways: token => dispatch(getGateways(token)),
  cancelAddNumber: () => dispatch(cancelAddNumber()),
  assignRouteInfo: (token, numId) => dispatch(assignRouteInfo(token, numId)),
  editNumberCancel: () => dispatch(editNumberCancel()),
  portConfig: (token, body) => dispatch(portConfig(token, body)),
  getPortValues: (token, obiId, values) => dispatch(getPortValues(token, obiId, values)),
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(getAssignedNumbers(token, cid, uid, priStatus)),
  updateNumber: (token, number) => dispatch(updateNumber(token, number)),
  forceFixNumber: (token, nid, bid) => dispatch(forceFixNumber(token, nid, bid)),
  selectPort: port => dispatch(selectBoxDetailsPort(port)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
  trunkPortConfig: (token, body) => dispatch(trunkPortConfig(token, body)),
  boundForwardNumber: (token, bid, body) => dispatch(boundForwardNumber(token, bid, body)),
  boundRemoveNumber: (token, bid, body) => dispatch(boundRemoveNumber(token, bid, body)),
  assignAction: description => dispatch(assignAction(description)),
  unassignAction: description => dispatch(unassignAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  disableAction: description => dispatch(disableAction(description)),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectedAtaPanel);
